import React, { useEffect, useState } from 'react'
import DashboardLayout from '../../layoutcontainers/DashboardLayout'
import { Card, CardContent, CardHeader, Grid2, LinearProgress, Stack } from '@mui/material'
import MaterialTypography from '../../components/MaterialTypography'
import { useLocation, useNavigate } from 'react-router-dom';
import BASEURL from '../Utils/Baseurl';
import request from 'graphql-request';
import { filterNotificationType, getAllNotifications } from './GraphQl';
import { BsEye } from 'react-icons/bs';
import CheckIcon from '@mui/icons-material/Check';
import MaterialSelect from '../../components/MasterSelect';
import MaterialBox from '../../components/MaterialBox';
import { useAuth } from '../../context/AuthContext/AuthContextProvider';
import MaterialButton from '../../components/MaterialButton';
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";

const NotificationList = () => {
    const { currentUser } = useAuth();
    const params = useLocation();
    const id = params.search.slice(1);
    const decodedId = atob(currentUser?.id);
    const userId = decodedId.split(":")[1];
    const navigate = useNavigate();

    const notificationOptions = [
      { value: "Task Assigned", label: "Task Assigned"},
        { value: "Task Update", label: "Task Update"},
        { value: "Call Log Created", label: "Call Log Created"},
        { value: "Call Log Updated", label: "Call Log Updated"},
        { value: "Email Logged", label: "Email Logged"},
        { value: "Email Log Updated", label: "Email Log Updated"},
        { value: "Visit Log Created", label: "Visit Log Created"},
        { value: "Visit Log Updated", label: "Visit Log Updated"},
        { value: "WhatsApp Log Created", label: "WhatsApp Log Created"},
        { value: "WhatsApp Log Updated", label: "WhatsApp Log Updated"},
    ];
    const [filterData, setFilterData] = useState({
      notificationType: "",
      notificationTypeStatus: "unchecked"
    });
    const [isLoading, setIsLoading] = useState(false);
    const [notifications, setNotifications] = useState([]);
    const [page, setPage] = useState(1);
    const itemsPerPage = 6;

    const paginatedNotifications = notifications.slice(
      (page - 1) * itemsPerPage,
      page * itemsPerPage
    );
    
    useEffect(() => {
      fetchAllNotifications();
    }, []);
    
    useEffect(() => {
       if(!userId) return;
        if ( userId) {
            fetchNotificationsFilter();
        }
    }, [ userId]);
    
    //Fetch Table Data
    const fetchNotificationsFilter = async () => {
        const query = `
          query AllNotifications($userId: Int!) {
            allNotifications(userId: $userId) {
              success
              message
              data {
                id
                message
                task{
                  title
                }
                isRead
                notificationType
                createdAt
              }
            }
          }
        `;
    
        const variables = {
          userId: userId,
        };
        setIsLoading(true);
        try {
          const response = await request(BASEURL, query, variables);
          setNotifications(response?.allNotifications?.data || []);
        } 
        catch (error) {
          console.error('Failed to fetch notifications:', error);
        }
        finally{
          setIsLoading(false)
        }
      };

      //Filter Function
      const filterNotificationFunction = async (selectedType) => {
        setIsLoading(true);
        const variables = {
          userId: userId,
          // userId: 2,
          notificationType: selectedType || null,
        };
        
        try {
          const response = await request(BASEURL, filterNotificationType, variables);
          if (response?.allNotifications?.success) {
            setNotifications(response.allNotifications.data);
            setPage(1);
          } else {
            console.error("Fetch failed:", response?.allNotifications?.message);
          }
        } catch (error) {
          console.error("Error Filtering Data:", error);
        }
        finally{
          setIsLoading(false);
        }
      };
      
      

    const fetchAllNotifications = async () => {
      setIsLoading(true);
        try {
          const response = await request(BASEURL, getAllNotifications);
          const data = response?.allNotifications?.data || [];
          setNotifications(data);
        } catch (error) {
          console.error("Failed to fetch notifications:", error);
        }
        finally{
          setIsLoading(false);
        }
    };

    const handleFilterChange = (selectedOption) => {
      setFilterData((prev) => ({
        ...prev,
        notificationType: selectedOption || null,
        notificationTypeStatus: selectedOption ? "success" : "unchecked",
      }));
    
      if (selectedOption?.value) {
        filterNotificationFunction(selectedOption.value);
      } else {
        fetchNotificationsFilter();
      }
    };
    
    
      
      
  return (
    <DashboardLayout>
    <Card>
      <CardHeader
        title={
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            spacing={2}
          >
            <Stack direction="column" spacing={0}>
              <MaterialTypography variant="h5" fontWeight="medium">
                Notification List
              </MaterialTypography>
            </Stack>
          </Stack>
        }
      />
  
      <CardContent sx={{ borderRadius: "10px", backgroundColor: "#f8f9fa", minHeight: "70vh" }}>
        {isLoading ? 
        <LinearProgress/> : 
        <Stack spacing={3}>
          <MaterialBox md="3">
            <Grid2 container spacing={2}>
              <Grid2 size={{ xs: 12, sm: 6 }}>
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Notification Type Filter
                </MaterialTypography>
                <MaterialSelect
                name="notificationType"
                value={filterData.notificationType}
                options={notificationOptions}
                onChange={handleFilterChange}
                customStyles={{ optionPadding: 20 }}
                success={filterData.notificationTypeStatus === "success"}
                />
              </Grid2>
            </Grid2>
          </MaterialBox>
  
          <Stack spacing={1.5}>
            {notifications.length === 0 ? (
              <MaterialTypography
                component="label"
                variant="h5"
                fontWeight="bold"
              >
                No Notifications available.
              </MaterialTypography>
            ) : (
              paginatedNotifications.map((notification, index) => (
                <Card
                  key={notification.id}
                  onClick={() =>
                    navigate(`/notification/view-notification?${notification.id}`)
                  }
                  sx={{
                    cursor: "pointer",
                    px: 2,
                    py: 1,
                    backgroundColor: `${notification.isRead ? "#f8f9fa" : "#f0e7f7"}`,
                    borderLeft: `4px solid ${notification.isRead ? "#ccc" : "#6a0dad"}`,
                    boxShadow: 1,
                    borderRadius: "4px",
                    transition: "transform 0.1s ease-in-out",
                    "&:hover": {
                      transform: "scale(1.01)",
                      backgroundColor: "#f5f5f5",
                    },
                  }}
                >
                  <Stack
                    direction="row"
                    spacing={2}
                    alignItems="center"
                    justifyContent="space-between"
                  >
                    {/* <MaterialTypography variant="body2" sx={{ width: 40 }}>
                      {notification.id}.
                    </MaterialTypography> */}
  
                    <MaterialTypography
                      variant="body2"
                      fontWeight="bold"
                      sx={{ flex: 2.5 }}
                    >
                      {notification.notificationType || "Notification"}
                    </MaterialTypography>
  
                    <MaterialTypography variant="body2" sx={{ flex: 2.5 }}>
                      {notification.task?.title || "N/A"}
                    </MaterialTypography>
  
                    <MaterialTypography variant="body2" sx={{ flex: 1 }}>
                      {notification.createdAt?.slice(0, 10) || "N/A"}
                    </MaterialTypography>
  
                    <MaterialTypography variant="body2" sx={{ flex: 1 }}>
                      {notification.createdAt?.slice(11, 19) || "N/A"}
                    </MaterialTypography>
  
                    <MaterialTypography
                      variant="body2"
                      sx={{
                        fontWeight: "bold",
                        color: notification.isRead ? "#616161" : "#6a0dad",
                        minWidth: 80,
                        textAlign: "right",
                      }}
                    >
                      {notification.isRead ? <CheckIcon /> : <BsEye />}
                    </MaterialTypography>
                  </Stack>
                </Card>
              ))
            )}
          </Stack>
        </Stack>
        }
      </CardContent>
  
      {Array.isArray(notifications) && notifications.length > 0 && (
        <Stack direction="row" spacing={2} justifyContent="center" sx={{ py: 2 }}>
          <MaterialButton
          variant="gradient"
          color="dark"
          disabled={page === 1}
          onClick={() => setPage((prev) => prev - 1)}
          >
            <NavigateBeforeIcon/>
            Newer
          </MaterialButton>
          <MaterialButton
          variant="gradient"
          color="dark"
          disabled={page * itemsPerPage >= notifications.length}
          onClick={() => setPage((prev) => prev + 1)}
          >
            Older
            <NavigateNextIcon />
          </MaterialButton>
        </Stack>
      )}
    </Card>
  </DashboardLayout>
  
  )
}

export default NotificationList